import App from './App.html';

var app = new App({
	target: document.body
});

export default app;
